import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["field", "errors", "addressSelect", "newAddressForm"]
  static values = { url: String }

  async submit(event) {
    event.preventDefault()
    event.stopPropagation()

    const requiredFields = this.element.querySelectorAll('[data-required]')
    let valid = true
    requiredFields.forEach(field => {
      if (!field.value.trim()) {
        field.classList.add('is-invalid')
        valid = false
      } else {
        field.classList.remove('is-invalid')
      }
    })

    if (!valid) {
      this.showError("Please fill in all required fields.")
      return
    }

    for (const field of this.fieldTargets) {
      if (!field.checkValidity()) {
        field.classList.add('is-invalid')
        this.showError(field.validationMessage || "Please correct the highlighted fields.")
        field.reportValidity()
        return
      } else {
        field.classList.remove('is-invalid')
      }
    }

    const formData = new FormData()
    this.fieldTargets.forEach(field => {
      if (field.name) formData.append(field.name, field.value)
    })

    try {
      await post(this.urlValue, {
        body: formData,
        responseKind: "turbo-stream",
        headers: { "Turbo-Frame": "isolated_new_address_form_frame" }
      })
    } catch (error) {
      console.error("Error saving address:", error)
      this.showError("Failed to save address. Please try again.")
    }
  }

  showError(message) {
    if (this.hasErrorsTarget) {
      const alert = document.createElement('div')
      alert.className = 'alert alert-danger'
      alert.textContent = message
      this.errorsTarget.replaceChildren(alert)
    }
  }

  cancelNewAddressForm() {
    this.fieldTargets.forEach(field => field.value = "")
    if (this.hasErrorsTarget) {
      this.errorsTarget.classList.add('d-none')
      this.errorsTarget.innerHTML = ""
    }
  }
}
